import React from 'react';
import './termasAndCondition.css';
import Footer from '../../Footer';

function C2wTermsAndConditions() {
  return (
    <div className="c2w_privacy">
        <h1>Terms And Conditions</h1>
        <p>
          End User License Agreement Core2Web is licensed to You (End-User) by
          Core2Web, located at Core2Web, 3rd Floor,
          Walhekar Properties, Narhe Road, Near Navale Bridge, Narhe, Pune,
          Maharashtra 411041, India (hereinafter Licensor), for use only under
          the terms of this License Agreement By downloading the Application
          from the Google Play Store, and any update thereto (as permitted by
          this License Agreement), You indicate that You agree to be bound by
          all of the terms and conditions of this License Agreement and that you
          accept this License Agreement. The parties of this License Agreement
          acknowledge that Google is not a Party to this License Agreement and
          is not bound by any provisions or obligations concerning the
          Application, such as warranty, liability, maintenance and support
          thereof. Core2Web, not Google, is solely responsible for
          the licensed application and the content thereof. This License
          Agreement may not provide for usage rules for the Application that
          conflicts with the latest Play Store Terms of Service Core2Web 
          acknowledges that it had the opportunity to review said
          terms and this License Agreement is not conflicting with them. All
          rights not expressly granted to You are reserved
        </p>

        <ol>
          <li>
            <h3>The Application</h3>
            <p>
              Core2Web (hereinafter. Application) is a piece of software created
              to To Share, Display and Publish technical content about computer
              and programming languages and customized for Android mobile
              devices. It is used to To Ask Questions, Queries and share
              Programming experiences.
            </p>
          </li>

          <li>
            <h3>Scope Of License</h3>
            <ul>
              <li>
                You are given a non-transferable, non-exclusive, non
                sublicensable license to install and use the Licensed
                Application on any Android branded products that You (End User)
                own or control and as permitted by the Usage Rules outlined in
                this section and the Play Store Terms of Service, with the
                exception that such licensed Application may be accessed and
                used by other accounts associated with You (End-User, The
                Purchaser) via Family Sharing or volume purchasing{" "}
              </li>
              <li>
                This license will also govern any updates of the Application
                provided by Licensor that replaces, repairs, and/or supplement
                the first Application unless a separate license is provided for
                such an update in which case the terms of that new license will
                govern.
              </li>
              <li>
                You may not share or make the Application available to third
                parties (unless to the degree allowed by the Google Terms and
                Conditions, and with Core2Web prior written
                consent), sell, rent, lend, lease or otherwise redistribute the
                Application.
              </li>
              <li>
                You may not reverse engineer, translate, disassemble, integrate,
                decompile, integrate, remove, modify, combine create derivative
                works or updates of, adapt, or attempt to derive the source code
                of the Application, or any part thereof (except with Core2Web
                prior written consent)
              </li>
              <li>
                Violations of the obligations mentioned above, as well as the
                attempt of such infringement, may be subject to prosecution and
                damages
              </li>
              <li>
                28 Nothing in this license should be interpreted to
                restrict third-party terms: When using the Application. You must
                ensure that you comply with applicable third-party terms and
                conditions
              </li>
            </ul>
          </li>

          <li>
            <h3>Technical Requirements</h3>
            <ul>
              <li>
                The Application requires a firmware Android 5.1 (Lollipop) (API
                Level 22) or higher. The licensor recommended using the latest
                version of the firmware.
              </li>
              <li>
                Licensor attempts to keep the Application updated so that it
                complies with modified/new versions of the firmware and new
                hardware You are not granted rights to claim such an update.
              </li>
              <li>
                You acknowledge that it is Your responsibility to confirm and
                determine that the app end-user device on which You intend to
                use the Application satisfies the technical specifications
                mentioned above.
              </li>
              <li>
                Licensor reserves the right to modify the technical
                specifications as it sees appropriate at any time.
              </li>
            </ul>
          </li>

          <li>
            <h3>Maintenance And Supports</h3>
            <ul>
              <li>
                The Licensor is solely responsible for providing any maintenance
                and support services for this licensed Application. You can
                reach the Licensor at the email address listed in the Play Store
                Overview for this licensed Application.
              </li>
              <li>
                Core2Web and the End User acknowledge that Google
                has no obligation whatsoever to furnish any maintenance and
                support services concerning the licensed application
              </li>
            </ul>
          </li>

          <li>
            <h3>Liability</h3>
            <ul>
              <li>
                Licensor's responsibility in the case of violation of
                obligations and tort shall be limited to intent and gross
                negligence. Only in case of a breach of essential contractual
                duties (cardinal obligations), Licensor shall also be liable in
                case of slight negligence. In any case, liability shall be
                limited to the foreseeable, contractually typical damages. The
                limitation mentioned above does not apply to injuries to life,
                limb, or health
              </li>
              <li>
                Licensor takes no accountability or responsibility for any
                damages caused due to a breach of duties according to Section 2
                of this Agreement. To avoid data loss, You are required to make
                use of backup functions of the Application to the extent allowed
                by applicable third-party terms and conditions of use. You are
                aware that in case of alterations or manipulations of the
                Application. You will not have access to licensed Application.
              </li>
            </ul>
          </li>

          <li>
            <h3>Warranty</h3>
            <ul>
              <li>
                Licensor warrants that the Application is free of spyware,
                trojan horses, viruses, or any other malware at the time of Your
                download Licensor warrants that the Application works as
                described in the user documentation.
              </li>
              <li>
                No warranty is provided for the Application that is not
                executable on the device, that has been without authorization modified,
                handled inappropriately or culpably, combined or installed with
                inappropriate hardware or software, used with Inappropriate
                accessories, regardless if by Yourself or by third parties, or
                if there are any other reasons outside of Core2Web's 
                sphere of influence that affect the executability
                of the Application.
              </li>
              <li>
                You are required to inspect the Application immediately after
                installing it and notify Core2Web about issues
                discovered without delay by e-mail provided "Product Claims. The
                defect report will be taken into consideration and further
                investigated if it has been mailed in within a period of thirty
                (30) days after discovery.
              </li>
              <li>
                If we confirm that the Application is defective, Core2Web 
                reserves a choice to remedy the situation either
                through solving the defect or substitute delivery.
              </li>
              <li>
                In the event of any failure of the Application to conform to any
                applicable warranty, You may notify the Play Store Operator, and
                Your Application purchase price will be refunded to You, To the
                maximum extent permitted by applicable law, the Play
                Store-Operator will have no other warranty obligation whatsoever
                concerning the App, and any other losses, claims, damages,
                liabilities, expenses, and costs attributable to any negligence
                to adhere to any warranty
              </li>
              <li>
                If the user is an entrepreneur, any claim based on faults
                expires after a statutory period of limitation amounting to
                twelve (12) months after the application was made available to
                the user. The statutory periods of limitation given by law apply
                for users who are consumers.
              </li>
            </ul>
          </li>

          <li>
            <h3>Product Claims</h3>
            <p>
              Core2Web and the End User acknowledge that Core2Web, 
              and not Google, is responsible for addressing any
              claims of the End-User or any third party relating to the licensed
              Application or the End-User's possession and/or use of that
              Licensed Application, including, but not limited to:
            </p>

            <p>
              product liability claims any claim that the licensed Application
              fails to conform to any applicable legal or regulatory requirement
              and claims arising under consumer protection, privacy, or similar
              legislation, including in connection with Your Licensed
              Application's use of the HealthKit and HomeKit
            </p>
          </li>

          {/* <li>
            <h3>Product Claims</h3>
            <p>
              Core2Web and the End User acknowledge that Core2Web, 
              and not Google, is responsible for addressing any
              claims of the End-User or any third party relating to the licensed
              Application or the End-User's possession and/or use of that
              Licensed Application, including, but not limited to:
            </p>

            <p>
              product liability claims any claim that the licensed Application
              fails to conform to any applicable legal or regulatory requirement
              and claims arising under consumer protection, privacy, or similar
              legislation, including in connection with Your Licensed
              Application's use of the HealthKit and HomeKit
            </p>
          </li> */}

          <li>
            <h3>Contact Information</h3>
            <p>
              For general inquiries, complaints, questions or claims concerning
              the licensed Application, please contact: Core2Web
              Core2Web, 3rd Floor, Walhekar Properties. Narhe Road
              Near Navale Bridge, Narhe Pune, Maharashtra 411041 India
              core2webinfo@gmail.com
            </p>
          </li>

          <li>
            <h3>Termination</h3>
            <p>
              The license is valid until terminated by Core2Web or
              by You. Your rights under this license will terminate
              automatically and without notice from Core2Web if You
              fail to adhere to any term(s) of this license. Upon License
              termination, You shall stop all use of the Application, and
              destroy all copies, full or partial, of the Application.
            </p>
          </li>

          <li>
            <h3>Third-party Terms Of Agreements And Beneficiary</h3>
            <p>
              Core2Web represents and warrants that Core2Web
              will comply with applicable third party terms of
              agreement when using licensed Application Under Section 9 of the
              instructions for Minimum Terms of Developer's End-User License
              Agreement. Google and Google's subsidiaries shall be third-party
              beneficiaries of this End User License Agreement and upon Your
              acceptance of the terms and conditions of this license agreement,
              Apple will have the right (and will be deemed to have accepted the
              right) to enforce this End User License Agreement against You as a
              third party beneficiary thereof.
            </p>
          </li>

          <li>
            <h3>Intellectual Property Rights </h3>
            <p>
              Core2Web and the End-User acknowledge that, in the
              event of any third party claim that the licensed Application or
              the End User's possession and use of that Licensed Application
              infringes on the third party's intellectual property rights,
              Core2Web, and not Google, will be solely responsible
              for the investigation, defense, settlement, and discharge of any
              such intellectual property infringement claims
            </p>

            <p>
              This license agreement is governed by excluding its conflicts of
              law rules
            </p>
          </li>

          <li>
            <h3>This license agreement is governed by the laws of India...</h3>
            <ul>
              <li>
                If any of the terms of this agreement should be or become
                invalid, the validity of the remaining provisions shall not be
                affected. Invalid terms will be replaced by valid ones
                formulated in a way that will achieve the primary purpose.
              </li>
              <li>
                Collateral agreements, changes, and amendments are only valid if laid down in writing. The preceding clause can only be waived in
                writing
              </li>
            </ul>
          </li>
        </ol>
          <div className="ADfooter__container">
          <Footer />
        </div>
      </div>
  )
}

export default C2wTermsAndConditions;

